<template>
  <div>
    <div v-if="cases.length > 0">
      <div
        class="report-viewer page-break"
        v-for="(page, index) in pages"
        :key="`page${index}`"
      >
        <div class="report-viewer-content">
          <div class="table-responsive position-relative">
            <table
              class="table table-sm table-bordered mb-0"
              id="headerTable"
              style="min-width: 100%"
            >
              <thead>
                <tr>
                  <th
                    rowspan="5"
                    style="width: 16.66%"
                    class="text-center border-transparent-bottom"
                  >
                    <img
                      src="@/assets/jkr.jpg"
                      class="w-100"
                      style="min-width: 80px"
                    />
                    <p class="mb-0 mt-2">JKR JOHOR</p>
                  </th>
                  <th
                    rowspan="5"
                    style="width: 49.99%; font-size: 1.3em"
                    class="text-center text-nowrap border-transparent-bottom"
                  >
                    PROSEDUR PENYELIAAN KERJA RUTIN
                  </th>
                  <td style="width: 16.66%" class="text-nowrap">
                    No Ruj. Dokumen
                  </td>
                  <td style="width: 16.66%" class="text-center text-nowrap">
                    JKR.PK(SJ).P.01
                  </td>
                </tr>
                <tr>
                  <td style="width: 16.66%" class="text-nowrap">
                    No. Keluaran
                  </td>
                  <td style="width: 16.66%" class="text-center text-nowrap">
                    00
                  </td>
                </tr>
                <tr>
                  <td style="width: 16.66%" class="text-nowrap">No. Pindaan</td>
                  <td style="width: 16.66%" class="text-center text-nowrap">
                    00
                  </td>
                </tr>
                <tr>
                  <td style="width: 16.66%" class="text-nowrap">Tarikh</td>
                  <td style="width: 16.66%" class="text-center text-nowrap">
                    {{ reportDate }}
                  </td>
                </tr>
                <tr>
                  <td
                    style="width: 16.66%"
                    class="text-nowrap border-transparent-bottom"
                  >
                    Muka Surat
                  </td>
                  <td
                    style="width: 16.66%"
                    class="text-center text-nowrap border-transparent-bottom"
                  >
                    {{ `${index + 1}/${pages.length}` }}
                  </td>
                </tr>
              </thead>
            </table>
            <table
              class="table table-sm table-bordered mb-0"
              id="mainTable"
              style="min-width: 100%"
            >
              <thead>
                <tr>
                  <th
                    colspan="2"
                    style="width: 50%"
                    class="
                      border-transparent-right
                      border-transparent-left
                      border-transparent-bottom
                    "
                  >
                    [Borang JKR.PK(SJ).P.01-25]
                  </th>
                  <th
                    colspan="2"
                    style="width: 50%"
                    class="
                      text-right
                      border-transparent-right border-transparent-bottom
                    "
                  >
                    LAMPIRAN 25
                  </th>
                </tr>
                <tr>
                  <th
                    colspan="4"
                    class="
                      h6
                      py-0
                      font-weight-bold
                      text-center
                      border-transparent-top
                      border-transparent-right
                      border-transparent-left
                      border-transparent-bottom
                    "
                  >
                    {{ reportHeader }}
                  </th>
                </tr>
                <tr>
                  <th
                    colspan="4"
                    class="
                      text-center
                      border-transparent-top
                      border-transparent-right
                      border-transparent-left
                      text-uppercase
                    "
                  >
                    LAPORAN BERGAMBAR
                    <span v-if="title">
                      {{ title }}
                    </span>
                    <span
                      class="font-weight-light font-italic text-muted"
                      v-else
                    >
                      Report name not specified
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-uppercase">NEGERI</td>
                  <td class="text-uppercase">{{ page.state }}</td>
                  <td class="text-uppercase">DAERAH</td>
                  <td class="text-uppercase">{{ page.district }}</td>
                </tr>
                <tr>
                  <td class="text-uppercase">NO. LALUAN</td>
                  <td class="text-uppercase">{{ page.ref }}</td>
                  <td class="text-uppercase">LALUAN</td>
                  <td class="text-uppercase">{{ page.road }}</td>
                </tr>
                <tr>
                  <td class="text-uppercase">KATEGORI JALAN</td>
                  <td class="text-uppercase">{{ page.roadCategory }}</td>
                  <td class="text-uppercase">TARIKH</td>
                  <td class="text-uppercase">{{ page.date }}</td>
                </tr>
                <tr>
                  <th
                    style="line-height: 10px"
                    class="p-0 border-transparent-left border-transparent-right"
                  ></th>
                  <th
                    style="line-height: 10px"
                    class="
                      p-0
                      border-transparent-left
                      border-transparent-right
                      border-transparent-bottom
                    "
                  ></th>
                  <th
                    style="line-height: 10px"
                    class="p-0 border-transparent-left border-transparent-right"
                  ></th>
                  <th
                    style="line-height: 10px"
                    class="
                      p-0
                      border-transparent-left
                      border-transparent-right
                      border-transparent-bottom
                    "
                  ></th>
                </tr>
                <tr>
                  <td>SEBELUM</td>
                  <td></td>
                  <td>SEBELUM</td>
                  <td class="border-transparent-right"></td>
                </tr>
                <tr class="report-case-image maintenance-image">
                  <td style="width: 50%" colspan="2">
                    <img
                      :src="formatMediaUrl(page.media[0])"
                      v-if="page.media && page.media[0]"
                    />
                  </td>
                  <td style="width: 50%" colspan="2">
                    <img
                      :src="formatMediaUrl(page.media[1])"
                      v-if="page.media && page.media.length > 1"
                    />
                  </td>
                </tr>
                <tr class="small">
                  <td>Skop Kerja</td>
                  <td>R03</td>
                  <td>Skop Kerja</td>
                  <td>R03</td>
                </tr>
                <tr class="small">
                  <td>Bulan</td>
                  <td class="text-uppercase">{{ page.month }}</td>
                  <td>Bulan</td>
                  <td class="text-uppercase">{{ page.month }}</td>
                </tr>
                <tr class="small">
                  <td>Seksyen</td>
                  <td>{{ page.section }}</td>
                  <td>Seksyen</td>
                  <td>{{ page.section }}</td>
                </tr>
                <tr>
                  <th
                    style="line-height: 10px"
                    class="p-0 border-transparent-left border-transparent-right"
                  ></th>
                  <th
                    style="line-height: 10px"
                    class="
                      p-0
                      border-transparent-left
                      border-transparent-right
                      border-transparent-bottom
                    "
                  ></th>
                  <th
                    style="line-height: 10px"
                    class="p-0 border-transparent-left border-transparent-right"
                  ></th>
                  <th
                    style="line-height: 10px"
                    class="
                      p-0
                      border-transparent-left
                      border-transparent-right
                      border-transparent-bottom
                    "
                  ></th>
                </tr>
                <tr>
                  <td>SEMASA</td>
                  <td></td>
                  <td>SEMASA</td>
                  <td class="border-transparent-right"></td>
                </tr>
                <tr class="report-case-image maintenance-image">
                  <td style="width: 50%" colspan="2">
                    <img
                      :src="formatMediaUrl(page.media_during[0])"
                      v-if="page.media_during && page.media_during[0]"
                    />
                  </td>
                  <td style="width: 50%" colspan="2">
                    <img
                      :src="formatMediaUrl(page.media_during[1])"
                      v-if="page.media_during && page.media_during.length > 1"
                    />
                  </td>
                </tr>
                <tr class="small">
                  <td>Skop Kerja</td>
                  <td>R03</td>
                  <td>Skop Kerja</td>
                  <td>R03</td>
                </tr>
                <tr class="small">
                  <td>Bulan</td>
                  <td class="text-uppercase">{{ page.month }}</td>
                  <td>Bulan</td>
                  <td class="text-uppercase">{{ page.month }}</td>
                </tr>
                <tr class="small">
                  <td>Seksyen</td>
                  <td>{{ page.section }}</td>
                  <td>Seksyen</td>
                  <td>{{ page.section }}</td>
                </tr>
                <tr>
                  <th
                    style="line-height: 10px"
                    class="p-0 border-transparent-left border-transparent-right"
                  ></th>
                  <th
                    style="line-height: 10px"
                    class="
                      p-0
                      border-transparent-left
                      border-transparent-right
                      border-transparent-bottom
                    "
                  ></th>
                  <th
                    style="line-height: 10px"
                    class="p-0 border-transparent-left border-transparent-right"
                  ></th>
                  <th
                    style="line-height: 10px"
                    class="
                      p-0
                      border-transparent-left
                      border-transparent-right
                      border-transparent-bottom
                    "
                  ></th>
                </tr>
                <tr>
                  <td>SELEPAS</td>
                  <td></td>
                  <td>SELEPAS</td>
                  <td class="border-transparent-right"></td>
                </tr>
                <tr class="report-case-image maintenance-image">
                  <td style="width: 50%" colspan="2">
                    <img
                      :src="formatMediaUrl(page.media_after[0])"
                      v-if="page.media_after && page.media_after[0]"
                    />
                  </td>
                  <td style="width: 50%" colspan="2">
                    <img
                      :src="formatMediaUrl(page.media_after[1])"
                      v-if="page.media_after && page.media_after.length > 1"
                    />
                  </td>
                </tr>
                <tr class="small">
                  <td>Skop Kerja</td>
                  <td>R03</td>
                  <td>Skop Kerja</td>
                  <td>R03</td>
                </tr>
                <tr class="small">
                  <td>Bulan</td>
                  <td class="text-uppercase">{{ page.month }}</td>
                  <td>Bulan</td>
                  <td class="text-uppercase">{{ page.month }}</td>
                </tr>
                <tr class="small">
                  <td>Seksyen</td>
                  <td>{{ page.section }}</td>
                  <td>Seksyen</td>
                  <td>{{ page.section }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      class="
        py-3
        w-100
        d-flex
        justify-content-center
        align-items-center
        text-loading
      "
      v-else
    >
      <span class="spinner-border spinner-border-sm mr-2" role="status"> </span>
      Loading report...
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Helper from "@/helper";

export default {
  name: "report-viewer",
  props: ["cases", "title", "district", "header"],
  data() {
    return {
      pages: [],
      state: "JOHOR",
      reportDistrict: "",
      reportHeader: "",
      reportDate: moment().format("DD MMM YYYY"),
    };
  },
  watch: {
    cases: {
      handler() {
        this.$emit("reportLoaded", false);

        if (this.cases.length > 0) {
          this.pages = [];

          this.pages = JSON.parse(JSON.stringify(this.cases)).map((p) => {
            return {
              state: "JOHOR",
              district: this.district,
              ref: p.road.ref,
              section: p.section,
              road: p.road.name,
              roadCategory: p.road.type,
              date: moment.unix(p.solveDate).format("DD.MM.YYYY"),
              month: moment.unix(p.solveDate).format("MMMM"),
              media: p.media,
              media_during: p.media_during,
              media_after: p.media_after,
            };
          });

          this.reportDistrict = this.district;
          this.reportHeader = this.header;

          this.$nextTick(() => {
            let reportContainer = document.getElementById("reportContainer");

            if (reportContainer) {
              reportContainer.scrollTop = 0;
            }

            this.setWidth();

            window.removeEventListener("resize", this.setWidth, true);

            window.addEventListener("resize", this.setWidth, true);

            this.$emit("reportLoaded", true);
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    formatMediaUrl(media) {
      return Helper.formatMediaUrl(media);
    },
    setWidth() {
      let mainTable = document.getElementById("mainTable");
      let headerTable = document.getElementById("headerTable");

      if (mainTable && headerTable) {
        if (mainTable > headerTable) {
          headerTable.style.width = `${mainTable.clientWidth}px`;
        } else {
          mainTable.style.width = `${headerTable.clientWidth}px`;
        }
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setWidth, true);
  },
};
</script>

<style lang="scss">
@import "@/assets/css/print.scss";
</style>
